import { combineReducers } from "redux";
import roulette from "../features/games/roulette/Slice";

const games = combineReducers({
  roulette: roulette,
});

export default games;
